"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var fwRUMReactAdapter = window.FW_RUM_REACT_ADAPTER;
var isEnabled = !!(window.FW_RUM && window.FW_RUM.isAnalyticsEnabled && fwRUMReactAdapter);

var InteractivityBeacon = /*#__PURE__*/function (_Component) {
  _inherits(InteractivityBeacon, _Component);

  var _super = _createSuper(InteractivityBeacon);

  function InteractivityBeacon(props) {
    var _this;

    _classCallCheck(this, InteractivityBeacon);

    _this = _super.call(this, props);
    _this.shouldRegisterBeaconPaintOnRemoval = false;
    return _this;
  }

  _createClass(InteractivityBeacon, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!isEnabled) {
        return;
      }

      fwRUMReactAdapter.registerBeaconAddition();
      var async = this.props.async || false;
      var trackingId = this.props.trackingId || null;

      if (!async && this.props.shouldTrackBeacon && trackingId) {
        fwRUMReactAdapter.trackEventOnce('BEACON_PAINT_#' + trackingId, fwRUMReactAdapter.EVENT_PRESETS['BEACON_PAINT']).markStart();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      if (!isEnabled) {
        return;
      }

      var async = this.props.async || false;
      var trackingId = this.props.trackingId || null;
      fwRUMReactAdapter.registerBeaconRemoval();
      /*
        This is done to mimic the ember hook that is called when a component
        is removed from DOM. Since there is no way to cancel the unmount of
        a component, we are fine with using timeout with 0 delay to defer the
        unmount confirmation to the next JS loop.
      */

      setTimeout(function () {
        fwRUMReactAdapter.resolveBeaconRemoval(async);

        if (_this2.shouldRegisterBeaconPaintOnRemoval) {
          var _fwRUMReactAdapter$tr;

          (_fwRUMReactAdapter$tr = fwRUMReactAdapter.trackEventOnce('BEACON_PAINT_#' + trackingId)) === null || _fwRUMReactAdapter$tr === void 0 ? void 0 : _fwRUMReactAdapter$tr.markStart();
        }

        fwRUMReactAdapter.reportInteractive();
      }, 0);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!isEnabled) {
        return;
      }

      var async = this.props.async || false;
      var trackingId = this.props.trackingId || null;
      fwRUMReactAdapter.resolveBeaconAddition(async);

      if (trackingId) {
        if (this.props.shouldTrackBeacon) {
          var _fwRUMReactAdapter$tr2;

          (_fwRUMReactAdapter$tr2 = fwRUMReactAdapter.trackEventOnce('BEACON_PAINT_#' + trackingId)) === null || _fwRUMReactAdapter$tr2 === void 0 ? void 0 : _fwRUMReactAdapter$tr2.markEnd().send();
        } else {
          /*
            When a non-meaningful-paint happens for a specific UI that has
            been instrumented, the beacon paint time is not reported. However,
            there is a possibility that this UI might update itself to a more
            meaningful state. When that happens, this beacon (rendered in the
            non-meaningful path) will be destroyed, and a new beacon with the
            same trackingId will be rendered (in the meaningful path). The
            beacon rendering time in this case is the time between the removal
            of the non-meaningful beacon and the rendering of the meaningful
            beacon. The following flag ensures that the start time is marked
            properly when the removal of this beacon gets resolved. If this is
            not done, whenever the UI updates with a meaningful paint, the beacon
            paint time will be calculated from the time of registration of the
            async beacon, and will hence report highly skewed metrics.
          */
          this.shouldRegisterBeaconPaintOnRemoval = true;
        }
      }

      fwRUMReactAdapter.reportInteractive(!this.props.skipReportingMeaningfulPaint);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  }]);

  return InteractivityBeacon;
}(_react.Component);

var _default = InteractivityBeacon;
exports.default = _default;